module.exports = __webpack_public_path__ + "static/media/cellwine-logo-black.6e013b2d.svg";